import { useState, useEffect, useCallback } from "react";
import api from "../Api";

export function useUserList() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userDocuments, setUserDocuments] = useState({});
    const [documentsError, setDocumentsError] = useState(null);

    const fetchAllUserDocuments = useCallback(async () => {
        if (users.length === 0) return;

        try {
            const results = await Promise.all(
                users.map(async (user) => {
                    const response = await api.get(`/users/${user.id}/documents`);
                    return { userId: user.id, documents: response.data };
                })
            );
            const docsMap = {};
            results.forEach(({ userId, documents }) => {
                docsMap[userId] = documents;
            });
            setUserDocuments(docsMap);
        } catch (err) {
            setDocumentsError("Fout bij laden documenten");
        }
    }, [users]);

    useEffect(() => {
        fetchUsers();
    }, []);

    useEffect(() => {
        if (users.length > 0) {
            fetchAllUserDocuments();
        }
    }, [users, fetchAllUserDocuments]);

    const fetchUsers = async () => {
        try {
            const response = await api.get("/users");
            setUsers(response.data);
        } catch (err) {
            setError("Er is iets foutgegaan bij het laden van de gebruikers.");
        } finally {
            setLoading(false);
        }
    };


    const inviteUser = async (email, role) => {
        await api.post("/users/invite", { email, role });
        fetchUsers();
    };

    const deleteUser = async (id) => {
        await api.delete(`/users/${id}`);
        setUsers((prev) => prev.filter((user) => user.id !== id));
    };

    return {
        users,
        loading,
        error,
        userDocuments,
        documentsError,
        inviteUser,
        deleteUser,
        fetchUsers
    };
}
